module.exports = __webpack_public_path__ + "static/SL99-f752f55fa04f7be99d86de64fdce0cc9.png";